import {Badge} from "@chakra-ui/react";
import {useTranslation} from "react-i18next";

const STATUS_STYLES = {
    active: { bg: "green.500", borderColor: "green.200" },
    draft:  { bg: "gray.600",  borderColor: "gray.400"  },
};
const DEFAULT_STYLE = { bg: "orange.500", borderColor: "orange.200" };

export const RecruitmentStatusBadge = ({status, badgeStyles}) => {
    const { t } = useTranslation("jobOffer");
    const key = status?.toLowerCase();
    const { bg, borderColor } = STATUS_STYLES[key] ?? DEFAULT_STYLE;
    const label = t(`enums.OFFER_STATUS.${key}`, t("enums.OFFER_STATUS.inactive"));

    return (
        <Badge
            bg={bg}
            borderColor={borderColor}
            borderWidth={1}
            variant="subtle"
            fontSize="xs"
            px={3}
            py={0.5}
            borderRadius={6}
            {...badgeStyles}
        >
            {label}
        </Badge>
    );
};